import { colors } from '@mui/material';
import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_LINE_WIDTH } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const pipelines: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'pipelines',
  dataType: 'pipelines',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Pipelines',
  description: '470k pipelines in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'pipelines',
    type: LayerType.Line,
    style: {
      width: DEFAULT_LINE_WIDTH,
      color: [
        'match',
        ['get', 'substance_mapping'],
        'Oil',
        'hsl(120, 100%, 50%)',
        'Gas',
        colors.pink['A400'],
        'Water',
        'hsl(220, 100%, 50%)',
        'Other',
        'hsl(270, 100%, 50%)',
        colors.grey[900],
      ],
    },
    source: {
      type: 'vector',
      minzoom: 6,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/pipelines/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/pipelines/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'pipelines',
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/pipelines',
    requiredMapDataFields: ['internal_id', 'geometry', 'substance_mapping'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'license_no',
      'line_segment_no',
      'substance',
      'comp_name',
      'seg_status',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'pipelines',
    dataType: 'pipelines',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
